import { Paper, Stack, Box } from "@mui/material"
import Invoices from "./Invoices"
import { HubConnection } from "@microsoft/signalr"
import { CreateButton } from "react-admin"
import Customers from "./Customers"
import AuditTrails from "./AuditTrails"

interface IProps {
  connection?: HubConnection
}

const Dashboard = ({connection}: IProps) => {

  return (
    <>
      <Box mt={2} mb={1} display={"flex"} justifyContent={"end"} >
        <CreateButton label="Rechnung erstellen" resource="invoices" variant='contained' color='success' />
      </Box>
      <Paper sx={{my: 1}}>
        <Stack p={4} spacing={5} direction={"row"} justifyContent={"space-between"} >
          <Invoices connection={connection} />
        </Stack>
        <Stack p={4} pt={4} pb={8} spacing={{xs: 8, xl: 5}} direction={{lg: "column", xl: "row"}} justifyContent={"space-between"} >
          <AuditTrails connection={connection} />
          <Customers connection={connection} />
        </Stack>
      </Paper>
    </>
  )
}

export default Dashboard